import {Col, Container, Nav, Navbar as NavbarBS, NavDropdown, Row} from "react-bootstrap"
import {useShoppingCart} from "../context/ShoppingCartContext"
import UserButtonMenu from "../components/UserButtonMenu";
import useAuth from "../hooks/useAuth";
import React, {Fragment} from "react";
import {LinkContainer,} from 'react-router-bootstrap'
import {Cart} from "../components/Cart";
import CartCheckOutButton from "../components/CartCheckOutButton";
import {isAuthenticated} from "../functions/isAuthenticated";
import DropdownItem from "react-bootstrap/DropdownItem";
import {Link} from "react-router-dom"
import DropdownMenu from "react-bootstrap/DropdownMenu";

export function Navbar() {
  const {isOpen, openCart, cartQuantity} = useShoppingCart()
  const {auth} = useAuth();

  return (
    <section className="navigation sticky-top">
      <Container>
        <Row className="align-items-center align-content-sm-start g-0">

          <Col xs={5} sm={8}>
            <NavbarBS expand="md">

              <NavbarBS.Toggle aria-controls="basic-navbar-nav" style={{background: "white", color: 'white'}}/>
              <NavbarBS.Collapse id="basic-navbar-nav">
                <Nav>

                  <LinkContainer to='/'>
                    <Nav.Link active={false}>HOME</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to='/products'>
                    <Nav.Link active={false}>PRODUCTS</Nav.Link>
                  </LinkContainer>

                  <NavDropdown title="SUPPORT" id="basic-nav-dropdown" className="ps-0 ps-sm-2" active={false}>
                    {/* <DropdownItem as={Link} to="/apply">Account Application</DropdownItem>*/}
                    <DropdownItem as={Link} to="https://istore.net.au/downloads">Product Manuals</DropdownItem>
                    {/*<NavDropdown.Divider/>*/}
                    <DropdownItem as={Link} to="/bulletin">Tech Bulletins</DropdownItem>


                  </NavDropdown>

                  <DropdownMenu className="dropdown__menu">
                    <Link to={`somewhere`}><DropdownItem>Edit</DropdownItem></Link>
                  </DropdownMenu>

                  <LinkContainer to="/about">
                    <Nav.Link active={false}>ABOUT</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to="/contact">
                    <Nav.Link active={false}>CONTACT</Nav.Link>
                  </LinkContainer>


                </Nav>
              </NavbarBS.Collapse>


            </NavbarBS>
          </Col>

          <Col xs={7} sm={4} className="text-end">
            {isAuthenticated(auth) && (
              <Fragment>
                <UserButtonMenu auth={auth}/>
                <CartCheckOutButton cartQuantity={cartQuantity} openCart={openCart}/>
              </Fragment>
            )}
          </Col>


        </Row>
      </Container>

      <Cart isOpen={isOpen}/>
    </section>
  )
}